import {
  Avatar,
  Badge,
  Button,
  Checkbox,
  Dropdown,
  List,
  Space,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import NotificationIcon from "../../../assets/icons/NotificationIcon";
import colors from "../../../constants/colors";

import { UserOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useAppSelector } from "../../../app/store";
import {
  useCheckNotificationMutation,
  useCheckNotificationsMutation,
  useGetNotificationCountQuery,
  useGetNotificationsQuery,
} from "../../../features/superAdmin/ticketService/ticketServiceApi";
import { toast } from "../../../lib/toast";
import CustomEmpty from "../../ui/CustomEmpty";
import Loader from "../../ui/Loader";
const { Text } = Typography;

export function formatCreatedAt(dateString: string): string {
  const date = dayjs(dateString);
  const isToday = dayjs().isSame(date, "day");
  const formattedTime = date.format("h:mm A");

  return isToday
    ? `Today, ${formattedTime}`
    : date.format("MMM D, YYYY, h:mm A");
}
export default function NotificationMenu() {
  const [openDropdown, setOpenDropdown] = useState(false);
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const userId = useAppSelector((state) => state.auth.user?.id);
  const [checkNotification, { isSuccess: marked }] =
    useCheckNotificationMutation();
  const [checkNotifications, { isSuccess, isLoading: checking }] =
    useCheckNotificationsMutation();

  const {
    data: notifications,
    isLoading,
    isFetching,
  } = useGetNotificationsQuery(userId, { skip: !userId });

  const { data: notificationsCount } = useGetNotificationCountQuery(userId, {
    skip: !userId,
  });

  const handleSelectAll = (e: any) => {
    if (e.target.checked) {
      const allIds = notifications?.data?.map((item) => item.id);
      setSelectedIds(allIds || []);
    } else {
      setSelectedIds([]);
    }
  };

  const handleSelect = (id: number, checked: boolean) => {
    setSelectedIds((prev) =>
      checked ? [...prev, id] : prev.filter((i) => i !== id),
    );
  };

  useEffect(() => {
    if (isSuccess) {
      setSelectedIds([]);
      setOpenDropdown(false);
      toast("success", "Notifications marked as read!");
    }
  }, [isSuccess]);
  useEffect(() => {
    if (marked) {
      setOpenDropdown(false);
      toast("success", "Notification marked as read!");
    }
  }, [marked]);

  return (
    <Dropdown
      trigger={["click"]}
      placement="bottomRight"
      arrow={{ pointAtCenter: true }}
      open={openDropdown}
      onOpenChange={setOpenDropdown}
      getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
      dropdownRender={() => (
        <div className="w-[400px] bg-white shadow rounded-md">
          <div className="flex items-center justify-between gap-2 p-4 shadow-sm shadow-gray-100 sticky top-0">
            <span className="text-xs text-header font-medium">
              Notifications
            </span>
            <button
              disabled={checking}
              className={`text-xs text-body font-medium hover:text-header disabled:opacity-80`}
              onClick={() => {
                checkNotifications({
                  ids: selectedIds,
                  receiverId: userId,
                });
              }}
            >
              {checking ? "Marking As Read" : "Mark As Read"}
            </button>
          </div>
          <div className="p-4">
            <Checkbox
              checked={
                selectedIds.length === notifications?.data?.length &&
                notifications?.data?.length > 0
              }
              indeterminate={
                selectedIds.length > 0 &&
                selectedIds.length < (notifications?.data?.length || 0)
              }
              onChange={handleSelectAll}
            >
              Select all ({notifications?.data?.length})
            </Checkbox>
          </div>
          <div className="mb-4">
            <div
              className="h-[300px] overflow-y-auto notification"
              onWheel={(e) => e.stopPropagation()}
            >
              {isLoading || isFetching ? (
                <Loader />
              ) : notifications?.data?.length ? (
                <div className="max-w-3xl mx-auto px-4">
                  <List
                    itemLayout="horizontal"
                    dataSource={notifications?.data}
                    renderItem={(item) => (
                      <List.Item>
                        <Space align="start">
                          <Checkbox
                            onClick={(e) => e.stopPropagation()}
                            checked={selectedIds.includes(item.id)}
                            onChange={(e) =>
                              handleSelect(item.id, e.target.checked)
                            }
                          />
                          <Avatar icon={<UserOutlined />} />
                          <div
                            className="cursor-pointer"
                            onClick={() => {
                              checkNotification({
                                id: item?.id,
                                receiverId: userId,
                              });
                            }}
                          >
                            <Text strong>{item.title}</Text>
                            <Text className="block">{item.text}</Text>
                            <div style={{ fontSize: 12, color: "#888" }}>
                              {formatCreatedAt(item.created_at)}
                            </div>
                            {/* <Button
                              type="default"
                              size="small"
                              className="border-[#FFD3C0] text-[#FE7235] bg-[#FFF1EB]"
                              style={{ marginTop: 8 }}
                            >
                              View TIcket
                            </Button> */}
                          </div>
                        </Space>
                      </List.Item>
                    )}
                  />
                </div>
              ) : (
                <CustomEmpty
                  rootClassName="pt-10"
                  imageStyle={{ height: 100 }}
                />
              )}
            </div>
          </div>
        </div>
      )}
    >
      <Badge
        count={notificationsCount?.data?.count}
        color={colors.danger.color}
        style={{
          width: "24px",
          height: "24px",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: 500,
          left: 4,
          top: 4,
        }}
        showZero
      >
        <Button
          className="border-none shadow-sm"
          icon={<NotificationIcon />}
          size="small"
        />
      </Badge>
    </Dropdown>
  );
}
